export enum EBannerStatus {
  Active = 'active',
  Paused = 'paused',
}
